import {useEffect, useRef, useState} from 'react';
export function useHeader() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef(null);

  useEffect(() => {
    const placeholder = headerRef.current;

    if (!placeholder?.parentElement) return;

    const parentElement = placeholder.parentElement;

    const resizeObserver = new ResizeObserver(() => {
      const parentHeight = parentElement.getBoundingClientRect().height;
      setHeaderHeight(parentHeight);
    });

    resizeObserver.observe(parentElement);

    return () => resizeObserver.disconnect();
  }, []);

  return {headerRef, headerHeight};
}
